module.exports = __webpack_public_path__ + "img/SurRealm_logo.c0ae08d1.png";